// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
// Type of this library doesn't work correct for wrapper
import { EditableInput, Hue, Saturation } from 'react-color/lib/components/common';
import React, { FC } from 'react';
import { CustomPicker, InjectedColorProps } from 'react-color';
import PickerPointer from './PickerPointer';
import PickerPointerCircle from './PickerPointerCircle';

const ColorPicker: FC<InjectedColorProps> = ({ hex, hsl, hsv, onChange }) => {
    return (
        <div>
            <div className={`relative pb-10/16 overflow-hidden w-full rounded-8`}>
                <Saturation
                    pointer={PickerPointerCircle}
                    hsl={hsl}
                    hsv={hsv}
                    rgb={hex}
                    hex={hex}
                    onChange={(color) => onChange(color)}
                />
            </div>
            <div className={`h-20 relative rounded-round overflow-hidden mt-16`}>
                <Hue hsl={hsl} pointer={PickerPointer} onChange={(color) => onChange(color)} />
            </div>
            <div className={`flex mt-20 items-center`}>
                <div className={`flex-auto text-16 text-primary-70`}>Hex</div>
                <div
                    className={`h-40 w-40 border border-primary-40 rounded flex-shrink-0 mr-10`}
                    style={{ background: hex }}
                ></div>
                <div
                    className={`w-110 px-16 border border-primary-40 rounded-8 text-18 text-primary-70 flex-shrink-0 leading-9 py-6`}
                >
                    <EditableInput style={{ input: { width: '100%' } }} value={hex} onChange={onChange} />
                </div>
            </div>
        </div>
    );
};

export default CustomPicker(ColorPicker);
